// removed by extract-text-webpack-plugin
module.exports = {"btnContainer":"_1T7ENd0EGubdEgZflNIriB","button":"_2Vn0dxatBiNI9nz0uT-hfw","loginLink":"_1xWpd8dXjsGNR6Ru-pWRCy","link":"_1iZmGHDdPXmY6Sc0RKtWrU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginFailedPopup/LoginFailed.module.scss
// module id = 2860
// module chunks = 0